import React from "react";
import { MessageSquare, Lightbulb, FileText, Printer } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: MessageSquare,
    title: "Tell us what your school wants to create",
    body: "Posters, banners, athletic displays, ceremony graphics—share your goals.",
  },
  {
    n: "02",
    icon: Lightbulb,
    title: "We recommend the right printer & package",
    body: "We match your needs, space, and budget to the right system.",
  },
  {
    n: "03",
    icon: FileText,
    title: "You receive a clear, easy-to-review quote",
    body: "No jargon, no surprises—just a clean quote built for school decision-makers.",
  },
  {
    n: "04",
    icon: Printer,
    title: "Start printing in-house with confidence",
    body: "Bring posters, banners, and signage on demand to your campus.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="bg-white py-24 md:py-32 border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-16 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
            The Process
          </div>
          <h2
            data-testid="how-it-works-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-navy leading-tight"
          >
            How It Works
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-4">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.n}
                data-testid={`step-${i}`}
                className="relative bg-[#F4F6F4] rounded-2xl p-7 lg:p-8 border border-slate-200 hover:border-teal hover:shadow-lg transition-all duration-300 group"
              >
                <div className="flex items-start justify-between mb-8">
                  <span className="font-serif text-5xl font-black text-teal/30 group-hover:text-teal/60 transition-colors leading-none">
                    {s.n}
                  </span>
                  <div className="w-11 h-11 rounded-lg bg-navy text-white flex items-center justify-center group-hover:bg-teal transition-colors">
                    <Icon className="w-5 h-5" strokeWidth={2} />
                  </div>
                </div>
                <h3 className="font-serif text-lg lg:text-xl font-bold text-navy mb-3 leading-snug">
                  {s.title}
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed">{s.body}</p>

                {i < STEPS.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-2 w-4 h-px bg-slate-300" />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
